import React, { useEffect, useState } from "react";
import Select from "react-select";
import Axios from "axios";
import CompaniesTable from "../components/Tables/CompaniesTable";
import SiteProgress from "../components/Loaders/SiteProgress";
import WeeklyDatePicker from "../../payments/paymentsComponents/WeeklyDatePicker";
import {
  ToastSuccess,
  ToastError,
  ToastClose,
  DownArrow,
  LSIcon,
  CalendarIcon,
  HouseIcon,
  LocationIcon,
  ApprovalFlagIcon,
} from "../components/helpers/svgHelper";

const approvalFlagList = [
  { label: "Unapproved", value: 0 },
  { label: "Approved", value: 1 },
];

function Site({
  loading,
  selectStyles,
  multiSelectStyles,
  companies,
  week,
  setWeek,
  fetchApprovalFlag,
  selectedCompanies,
  setSelectedCompanies,
  fetchSiteOverview,
  siteOverview,
  setSiteOverview,
  updateSiteOverviewTrips,
  downloadSiteCsv,
  downloadXeroCsv,
  toast,
  setToast,
  currentPage,
  hasMore,
  handleNext,
  handleBack,
  isAdmin,
}) {
  // const [selectedWeek, setSelectedWeek] = useState(null);
  // const [selectedCompany, setSelectedCompany] = useState(1);
  // const [selectedOption, setSelectedOption] = useState(null);
  // const [dropdown, setDropdown] = useState(false);

  // new states

  const [dropdown, setDropdown] = useState(false);
  const [tripTotal, setTripTotal] = useState(null);
  const [tripTracked, setTripTracked] = useState(null);
  const [selectedApprovalFlag, setSelectedApprovalFlag] = useState(null);
  const [approvedBy, setApprovedBy] = useState(null);
  // const [progressValue, setProgressValue] = useState(0);

  useEffect(() => {
    resetFilters();
  }, []);

  useEffect(() => {
    if (Object.keys(siteOverview).length === 0) {
      setTripTotal(null);
      setTripTracked(null);
      setApprovedBy(null);
      setSelectedApprovalFlag(null);
      return;
    }

    setTripTotal(siteOverview.grouped_trips_total);
    setTripTracked(siteOverview.total_tracked);

    const trips = siteOverview.grouped_trip_data ?? [];
    const allApproved =
      trips.length > 0 && trips.every((trip) => trip.approved_by !== null);

    setApprovedBy(allApproved ? trips[0].approved_by : null);
    setSelectedApprovalFlag(allApproved ? 1 : 0);
  }, [siteOverview]);

  const resetFilters = () => {
    setSelectedCompanies([]);
    setSiteOverview({});
  };

  // const [companyDropdown, setCompanyDropdown] = useState(false);

  const companiesSelect = () => {
    const formatedCompanies = companies.map((company) => {
      return { label: company.name, value: company.id };
    });
    return formatedCompanies;
  };

  const onChangedSelectedCompanies = (companySelected) => {
    setSelectedCompanies(companySelected);
  };

  const onChangedApprovalFlag = (approvalFlag) => {
    setSelectedApprovalFlag(approvalFlag.value);
  };

  // Disabled when: no site overview data, OR (non-admin AND total trips !== checked trips)
  const isTripsMismatch =
    tripTotal != null && tripTracked != null && tripTotal !== tripTracked;
  const shouldDisableDownload =
    Object.keys(siteOverview).length <= 0 || (!isAdmin && isTripsMismatch);

  // eof new states

  return (
    <div className="bg-transparent pt-2 pb-4 space-y-4">
      {loading && (
        <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-50 flex flex-col items-center justify-center">
          <div className="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
        </div>
      )}
      <div className="flex flex-row justify-between px-4">
        {toast.show && (
          <div className="fixed top-10 right-50 w-[400px] p-4 bg-white shadow-lg rounded-lg flex items-center justify-between border border-gray-300 z-50">
            <div className="flex items-center gap-3">
              {toast.type === "success" ? <ToastSuccess /> : <ToastError />}
              <div>
                <p className="text-black font-medium">{toast.message}</p>
                <p className="text-gray-500 text-sm">
                  Anyone with a link can now view this file.
                </p>
              </div>
            </div>
            <button onClick={() => setToast({ show: false })}>
              <ToastClose />
            </button>
          </div>
        )}
        <div className="flex flex-row w-11/12 space-x-2">
          {/* <div style={{ maxWidth: '170px' }}>
            <div className="relative flex items-center">
              <input
                type="text"
                placeholder="Search"
                style={{ paddingTop: '0.44rem', paddingBottom: '0.44rem' }}
                className="w-full pl-4 pr-10 text-gray-800 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 placeholder-gray-400 placeholder-opacity-100 font-light text-sm"
              />
              <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <svg
                  className="w-5 h-5 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                </svg>
              </div>
            </div>
          </div> */}
          <div className="w-2/5" style={{ height: "40px" }}>
            <Select
              value={selectedCompanies}
              onChange={onChangedSelectedCompanies}
              options={companiesSelect()}
              placeholder="Company"
              styles={selectStyles}
            />

            {/* Start */}
            {/* <div className="relative inline-block text-left w-full">
                <div className='w-full'>
                  <button
                    type="button"
                    // style={{ width: '150px' }}
                    onClick={() => setCompanyDropdown(!companyDropdown)}
                    className="inline-flex w-full justify-between gap-x-1.5 border-gray-400 border rounded-md bg-white text-gray-400 px-3 py-2 text-sm font-thin shadow-sm">
                    {selectedCompanies.length > 0 ? `${selectedCompanies.length} Selected` : 'Company'}
                    <svg
                      className="-mr-1 h-5 w-5 text-gray-400"
                      viewBox="0 0 20 20"
                      fill="currentColor">
                      <path
                        fillRule="evenodd"
                        d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
                {companyDropdown && (
                  <div
                    style={{ maxHeight: '250px' }}
                    className="absolute right-10 z-10 mt-2 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none overflow-y-auto scrollbar">
                    {companiesSelect().map((company, index) => (
                      <div
                        key={index}
                        className="py-2 px-4 flex flex-row items-center justify-between cursor-pointer hover:bg-gray-100"
                        onClick={() => onChangedSelectedCompanies(company)}>
                        <span className="block text-sm font-light text-gray-700">
                          [{company.label}]
                        </span>
                        <SiteProgress
                          totalTrips={company.totalTrips}
                          checkedTrips={company.checkedTrips}
                          isDropdown={true}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div> */}
            {/* eof */}
          </div>
          <div className="relative inline-block text-left">
            <div>
              <button
                type="button"
                style={{ width: "150px" }}
                onClick={() => setDropdown(!dropdown)}
                className="inline-flex w-full justify-between gap-x-1.5 border-gray-400 border rounded-md bg-white text-gray-400 px-3 py-2 text-xxs font-thin shadow-sm"
              >
                {week.from} - {week.to}
                <DownArrow />
              </button>
            </div>
            {dropdown && (
              <WeeklyDatePicker
                setWeek={setWeek}
                week={week}
                dropdown={dropdown}
                setDropdown={setDropdown}
              />
            )}
          </div>
          <div className="flex space-x-2">
            <button
              disabled={selectedCompanies.length === 0}
              onClick={() => fetchSiteOverview(1)}
              className={
                selectedCompanies.length === 0
                  ? "bg-gray-400 text-gray-600 font-normal text-sm py-1 px-4 rounded-lg"
                  : "bg-purple-600 text-white font-normal text-sm py-1 px-4 rounded-lg"
              }
            >
              Apply Filters
            </button>

            <button
              onClick={resetFilters}
              className="border border-gray-300 text-gray-600 font-normal text-sm py-1 px-4 rounded-lg"
            >
              Reset Filters
            </button>

            <span
              className="relative inline-block"
              title={
                shouldDisableDownload
                  ? "Button will get enabled when all trips are processed"
                  : undefined
              }
            >
              <button
                onClick={downloadSiteCsv}
                disabled={shouldDisableDownload}
                className={
                  shouldDisableDownload
                    ? "bg-gray-400 text-gray-600 font-normal text-sm py-2 px-4 rounded-lg"
                    : "bg-purple-600 text-white font-normal text-sm py-2 px-4 rounded-lg"
                }
              >
                Download CSV
              </button>
            </span>

            {isAdmin && (
              <button
                onClick={downloadXeroCsv}
                disabled={selectedCompanies.length === 0 || Object.keys(siteOverview).length <= 0}
                className={
                  selectedCompanies.length === 0 || Object.keys(siteOverview).length <= 0
                    ? "bg-gray-400 text-gray-600 font-normal text-sm py-1 px-4 rounded-lg"
                    : "bg-purple-600 text-white font-normal text-sm py-1 px-4 rounded-lg"
                }
              >
                Download Xero CSV
              </button>
            )}
          </div>
        </div>
      </div>

      {Object.keys(siteOverview).length > 0 && (
        <>
          <div className="flex flex-row justify-between px-4">
            <div className="flex flex-col justify-self-end items-start space-x-4 text-gray-600 text-sm">
              <div className="flex items-center space-x-1">
                <span className="font-semibold">
                  {siteOverview.company_data.name}
                </span>
                <span>Week of </span>
                <span className="text-gray-500">
                  {siteOverview.company_data.week}
                </span>
              </div>

              <div
                className="flex items-center space-x-4 w-1/2"
                style={{ marginLeft: "-1.5px" }}
              >
                <div className="flex items-start space-x-1">
                  <LSIcon />
                  <span className="text-gray-500">
                    {siteOverview.company_data.assigned_ls}
                  </span>
                </div>

                <div className="flex items-start space-x-1">
                  <CalendarIcon />
                  <span className="text-gray-500">
                    {siteOverview.company_data.date_range}
                  </span>
                </div>

                <div className="flex items-start space-x-1">
                  <HouseIcon />
                  <span className="text-gray-500">
                    {siteOverview.company_data.address}
                  </span>
                </div>

                <div className="flex items-start space-x-1">
                  <LocationIcon />
                  <span className="text-gray-500">
                    {siteOverview.company_data.region}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex flex-col space-y-1">
              {/* <div className="flex flex-row space-x-1">
                <div className="relative inline-block text-left">
                  <div>
                    <button
                      type="button"
                      style={{ width: '150px' }}
                      onClick={() => setDropdown(!dropdown)}
                      className="inline-flex w-full justify-between gap-x-1.5 border-gray-400 border rounded-md bg-white text-gray-400 px-3 py-2 text-sm font-thin shadow-sm">
                      Options
                      <svg
                        className="-mr-1 h-5 w-5 text-gray-400"
                        viewBox="0 0 20 20"
                        fill="currentColor">
                        <path
                          fillRule="evenodd"
                          d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>
                  {dropdown && (
                    <div
                      style={{ maxHeight: '250px', width: '20rem' }}
                      className="absolute right-0 z-10 mt-2 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none overflow-y-auto scrollbar">
                      {companies.map((company, index) => (
                        <div
                          key={index}
                          className="py-2 px-4 flex flex-row items-center justify-between">
                          <span className="block text-sm font-light text-gray-700">
                            {`[${company.name}]`}
                          </span>
                          <SiteProgress
                            totalTrips={company.totalTrips}
                            checkedTrips={company.checkedTrips}
                            isDropdown={true}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <button className="p-2 bg-purple-600 rounded hover:bg-purple-200">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M11 1V5H5.00001V1M3.00001 1H13L17.0001 5V15C17.0001 15.5304 16.7893 16.0391 16.4143 16.4142C16.0392 16.7893 15.5305 17 15.0001 17H3.00001C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3.00001 1ZM7.00002 11C7.00002 11.5304 7.21074 12.0391 7.58581 12.4142C7.96089 12.7893 8.46959 13 9.00003 13C9.53046 13 10.0392 12.7893 10.4142 12.4142C10.7893 12.0391 11 11.5304 11 11C11 10.4696 10.7893 9.96086 10.4142 9.58579C10.0392 9.21071 9.53046 9 9.00003 9C8.46959 9 7.96089 9.21071 7.58581 9.58579C7.21074 9.96086 7.00002 10.4696 7.00002 11Z"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div> */}

              {isAdmin && (
                <div className="flex flex-row space-x-1 items-center">
                  <div className="relative">
                    {approvedBy === null ? (
                      <Select
                        value={approvalFlagList.find(
                          (opt) => opt.value === selectedApprovalFlag
                        )}
                        onChange={onChangedApprovalFlag}
                        options={approvalFlagList}
                        placeholder="Approval Flag"
                        styles={selectStyles}
                      />
                    ) : (
                      <>Approved by {approvedBy}</>
                    )}
                  </div>

                  <button
                    onClick={() => fetchApprovalFlag(selectedApprovalFlag)}
                    className={
                      approvedBy === null
                        ? "p-2 bg-purple-600 rounded hover:bg-purple-200"
                        : "hidden"
                    }
                  >
                    <ApprovalFlagIcon />
                  </button>
                </div>
              )}

              <SiteProgress
                totalTrips={tripTotal}
                checkedTrips={tripTracked}
                isActive={true}
              />
            </div>
          </div>

          {siteOverview.grouped_trip_data.length > 0 ? (
            <div className="flex flex-col space-y-2 justify-between">
              <div className="px-4 border-t border-gray-400" />

              <div
                className="overflow-y-auto px-4 scrollbar"
                style={{ maxHeight: "800px" }}
              >
                <CompaniesTable
                  data={siteOverview}
                  updateSiteOverviewTrips={updateSiteOverviewTrips}
                  styles={selectStyles}
                  currentPage={currentPage}
                  hasMore={hasMore}
                  fetchSiteOverview={fetchSiteOverview}
                  handleNext={handleNext}
                  handleBack={handleBack}
                  isAdmin={isAdmin}
                />
              </div>
            </div>
          ) : (
            <div
              className="overflow-y-auto px-4 scrollbar"
              style={{ maxHeight: "800px" }}
            >
              No Site Data
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Site;
